import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { User } from '@shared/index';
import { KeyValEntry } from '@shared/KeyValStore';
import { AccesscontrolService } from '../services/accesscontrol.service';
import { AdminService } from '@shared-angular/services/admin.service';
import { RouteShareService } from '../services/route-share.service';

export const userKeyValResolver: ResolveFn<{ users: User<string, string>[], keyvals: KeyValEntry<string>[] }> = async () => {
  const rss = inject(RouteShareService);
  const adminService = inject(AdminService);
  const accessService = inject(AccesscontrolService);
  const botId: string = rss.botConfig._id;
  await accessService.loadUserList();
  const users = await adminService.getUsers();
  const guests = accessService.kiToolUserList;


  const l = await adminService.getUserValues(botId);
  console.log('KeyValResolver', l);
  const keyvals = await adminService.getUserValues(botId);
  keyvals.map(kv => {
    kv.value = kv.value + "";
    return kv;
  });
  return { users, guests, keyvals };
};

